import { render, staticRenderFns } from "./TestingCenterDayCard.vue?vue&type=template&id=c802dc70&"
import script from "./TestingCenterDayCard.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterDayCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports